import React, { useEffect, useState } from "react";
import DevicesTable from "./components/DevicesTable";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";
import { updateObject } from "../../../helpers/updateObject";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import Filter from "./modals/Filter";
import ReactDatePicker from "../UI/ReactDatePicker2";
const data = [
  {
    id: "device_restart",
    name: "device_restart",
  },
  {
    id: "	device_delete	",
    name: "	device_delete	",
  },
  {
    id: "device_create",
    name: "device_create",
  },
  {
    id: "device_edit",
    name: "device_edit",
  },
  {
    id: "check_connection",
    name: "check_connection",
  },
  {
    id: "device_synchronization",
    name: "device_synchronization",
  },
  {
    id:"device_log_error",
    name:"device_log_error"
  }

]

function Devices(props) {
  const [devices, setDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDevicesIds, setDeleteDevicesIds] = useState([]);

  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [showFilter, setShowFilter] = React.useState(false);
  var date = new Date();

  const [filterInputs, setFilterInputs] = useState({

    deviceId: "",
    devicePlaceId: "",
    ip: "",
    operation: "",
    status: "",

    start: new Date(
      new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0) -
      new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T").join(" ").split(".")[0],


    end: new Date(
      new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999) - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T").join(" ").split(".")[0],


  });

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onDevices = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      start,
      end,
      deviceId,
      devicePlaceId,
      ip,
      operation,
      status,
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}device-log?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${deviceId ? `&deviceId=${deviceId}` : ""}${devicePlaceId ? `&devicePlaceId=${devicePlaceId}` : ""}${end ? `&end=${end}` : ""}${ip ? `&ip=${ip}` : ""}${operation ? `&operation=${operation}` : ""}${start ? `&start=${start}` : ""}${status ? `&status=${status}` : ""}`)
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setDevices(content);
        setIsError(false);
        setCount(totalElements)

      })
      .catch(() => {
        setIsLoading(false);
        setDevices([]);
        setIsError(true);
      });
  };



  const onDeviceLogFilterExport = () => {

    axios
      .get(`${process.env.REACT_APP_API_URL}device-log/excel?${filterInputs.deviceId ? `&deviceId=${filterInputs.deviceId}` : ""}${filterInputs.devicePlaceId ? `&devicePlaceId=${filterInputs.devicePlaceId}` : ""}${filterInputs.end ? `&end=${filterInputs.end}` : ""}${filterInputs.ip ? `&ip=${filterInputs.ip}` : ""}${filterInputs.operation ? `&operation=${filterInputs.operation}` : ""}${filterInputs.start ? `&start=${filterInputs.start}` : ""}${filterInputs.status ? `&status=${filterInputs.status}` : ""}`,

        {
          responseType: "blob",

        }
      ).then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Device-log.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };



  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };



  useEffect(() => {
    const timer = setTimeout(() => {
      onDevices(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);



  const [devicePlaceId, setDevicePlaceId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}devicePlace`)
      .then(({ data: { content } }) => {
        const models = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDevicePlaceId(models);
      });
  }, []);


  const [deviceId, setDeviceId] = useState();


  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}device/select`)
      .then(({ data }) => {
        const deviceId = data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceId(deviceId);
      });
  }, []);


  const [operation, setOperation] = useState();

  useEffect(() => {
    const operationSelectData = data.map(({ id, name }) => ({
      value: id,
      label: name,
    }));

    setOperation(operationSelectData);
  }, []);

  return (
    <div className="row bg-white rounded">
      <div className=" row mb-0 mt-5 mx-0 d-flex w-100 justify-content-between">
        <div className=" col-5 "> <h1 className="display-4 mb-0"> Qurğu əməliyyatları hesabatı</h1></div>
        <div className=" row mb-0 mt-5 d-flex w-100 justify-content-end col-7">
          <div className="col-4 timeInterval">
            <ReactDatePicker
              id="start"
              name="start"
              label="Başlama tarixi"
              filterInputsUpdateKey={filterInputsUpdate}
              value={new Date(filterInputs.start)}
            />

          </div>
          <div className="col-4 timeInterval">
            <ReactDatePicker
              id="end"
              name="end"
              label="Bitmə tarixi"
              filterInputsUpdateKey={filterInputsUpdate}
              showTime={false}
              value={new Date(filterInputs.end)}
            />
          </div>
          <div className=" col-4 d-flex justify-content-end">
            <FormControlLabel
              control={
                <Switch
                  checked={showFilter}
                  onChange={handleChange}
                  color="secondary"
                />
              }
              label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
              className="ml-auto mb-0"
            />
          </div>
        </div>

      </div>
      <Divider className="w-100" />
      <DevicesTable
        devices={devices}
        isLoading={isLoading}
        isError={isError}
        setDeleteDevicesIds={setDeleteDevicesIds}
        deleteDevicesIds={deleteDevicesIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        onDeviceLogFilterExport={onDeviceLogFilterExport}
      />

      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        devicePlaceId={devicePlaceId}
        deviceId={deviceId}
        operation={operation}
      />
    </div>
  );
}

export default Devices;
